// extracted by mini-css-extract-plugin
export default {"cartBtn":"styles_cartBtn__6YVZp","icon":"styles_icon__25XPu","price":"styles_price__Rgb8s"};